import { z } from 'zod';

const CATEGORIES = ['', 'CONTRACT', 'NOTE', 'MEMO'] as const;

/** 표본 추가 폼 스키마 — react-hook-form resolver 로 연결 */
export const tenantSampleCreateSchema = z.object({
  label: z
    .string()
    .min(1, '라벨을 입력하세요')
    .max(100, '라벨은 100자 이내여야 합니다'),
  category: z.enum(CATEGORIES).optional(),
  secret: z.string().max(512, '민감값은 512자 이내여야 합니다').optional(),
  note: z.string().max(512, '메모는 512자 이내여야 합니다').optional(),
});

export type TenantSampleCreateFormValues = z.infer<typeof tenantSampleCreateSchema>;

/** 표본 목록 검색 스키마 */
export const sampleSearchSchema = z.object({
  category: z.enum(CATEGORIES).optional(),
  keyword: z.string().max(128).optional(),
  page: z.number().int().min(0).optional(),
  size: z.number().int().min(1).max(100).optional(),
  sort: z.string().optional(),
});

export type SampleSearchFormValues = z.infer<typeof sampleSearchSchema>;
